import { Injectable } from '@angular/core';
import { Action, createSelector, State, StateContext } from '@ngxs/store';
import { AddOrderAction } from './orders.actions';
import { WooCommerceCheckoutResponse } from '../../../core/interfaces/woo-commerce/api/checkout/checkout-api.interface';

interface OrdersStateModel {
  items: WooCommerceCheckoutResponse[];
}

const defaults = {
  items: []
};

@State<OrdersStateModel>({
  name: 'orders',
  defaults
})
@Injectable()
export class OrdersState {
  static getOrderById(rawOrderId: number | string) {
    return createSelector([OrdersState], (state: OrdersStateModel) => {
      const orderId: number =
        typeof rawOrderId === 'string' ? parseInt(rawOrderId, 10) : rawOrderId;

      return state.items.find(({ order_id }: WooCommerceCheckoutResponse) => {
        return order_id === orderId;
      });
    });
  }

  @Action(AddOrderAction)
  addOrder(
    { getState, setState }: StateContext<OrdersStateModel>,
    { payload }: AddOrderAction
  ) {
    const state = getState();

    const payloadCopy = JSON.parse(JSON.stringify(payload));
    if (payloadCopy.expected_delivery_date == null) {
      payloadCopy.expected_delivery_date = new Date().toISOString();
    }

    setState({ items: [...state.items, payloadCopy] });
  }
}
